var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.item && _vm.item.ad_code)?_c('a',_vm._g({staticClass:"advertse",on:{"click":_vm.clickAd}},_vm.$attrs),[_c('img',{attrs:{"src":_vm.item.ad_code,"alt":_vm.item.ad_name}})]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }